/**
 * Reusable required label component
 * @module FormFields/RequiredLabel
 */

import React, { memo } from 'react';

/**
 * Props for RequiredLabel component
 */
export interface RequiredLabelProps {
  /** Label text */
  children: React.ReactNode;
  /** Required marker symbol (defaults to '*') */
  marker?: string;
}

/**
 * Label with required field marker
 * Displays a red asterisk or custom marker next to label text to indicate required fields
 * 
 * @param props - Component props
 * @param props.children - Label text content
 * @param props.marker - Optional custom marker symbol (defaults to '*')
 * @returns RequiredLabel component
 */
export const RequiredLabel = memo<RequiredLabelProps>(({ children, marker = '*' }) => (
  <>
    {children}
    <span className="text-[#D00000] ml-0.5!">{marker}</span>
  </>
));

RequiredLabel.displayName = 'RequiredLabel';
